var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.appLoading),expression:"appLoading"}],staticClass:"app"},[(_vm.getRoute)?_c('keep-alive',[_c('router-view')],1):_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }